import React, { useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import Footer from './components/Footer';
import Navbars from './components/Navbars';
import Sidebar from './components/Sidebar';
import NotFound from 'pages/NotFound';
import LoginPage from 'pages/login';
import ScalePage from 'pages/scale';
import DashboardPage from 'pages/dashboard';
import { isLoggedIn } from 'utils/helpers';
import { RedirectHomePage } from 'components/RedirectHomePage';
import { RedirectPage } from 'components/RedirectPage';
import EventPage from 'pages/event';
import EventForm from 'pages/event-form';
import EventView from './pages/event-view';
import StudentPage from './pages/student';
import StudentView from './pages/student-view';
import TestimonialPage from 'pages/testimonial';
import ProductPage from 'pages/product';
import CoursesPage from 'pages/courses';
// import { routes } from './router/config';

const RouteWithLoader = ({ component: Component, ...rest }: any) => {
    const isAuth = isLoggedIn();

    return !isAuth ? (
        <Route
            {...rest}
            render={(props) => (
                <>
                    <Component {...props} />{' '}
                </>
            )}
        />
    ) : (
        <RedirectHomePage />
    );
};

const RouteWithSidebar = ({ component: Component, ...rest }: any) => {
    const localStorageIsSettingsVisible = () => {
        return localStorage.getItem('settingsVisible') === 'false' ? false : true;
    };

    const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
        localStorage.setItem('settingsVisible', JSON.stringify(!showSettings));
    };

    const isAuth = isLoggedIn();

    return isAuth ? (
        <Route
            {...rest}
            render={(props) => (
                <>
                    <Sidebar />

                    <main className="content">
                        <Navbars />
                        <Component {...props} />
                        <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
                    </main>
                </>
            )}
        />
    ) : (
        <RedirectPage />
    );
};

const App = () => {
    return (
        <React.Fragment>
            <Switch>
                <RouteWithSidebar exact path={'/'} component={DashboardPage} />
                <RouteWithLoader exact path={'/login'} component={LoginPage} />
                {/* Event */}
                <RouteWithSidebar exact path={'/events'} component={EventPage} />
                <RouteWithSidebar exact path={'/events/add'} component={EventForm} />
                <RouteWithSidebar exact path={'/events/:eventId/update'} component={EventForm} />
                <RouteWithSidebar exact path={'/events/:eventId/view'} component={EventView} />

                <RouteWithSidebar exact path={'/products'} component={ProductPage} />
                <RouteWithSidebar exact path={'/courses'} component={CoursesPage} />
                <RouteWithSidebar exact path={'/testimonials'} component={TestimonialPage} />

                <RouteWithSidebar exact path={'/students'} component={StudentPage} />
                <RouteWithSidebar exact path={'/students/:studentId/view'} component={StudentView} />

                <RouteWithSidebar exact path={'/scale'} component={ScalePage} />

                <RouteWithLoader exact path={'*'} component={NotFound} />
            </Switch>
        </React.Fragment>
    );
};

export default App;
